module.exports = __webpack_public_path__ + "static/media/3DPPA3.11bd5f2b.jpg";